import { WorkbenchManager } from './workbench_manager';

export var TopicSelector = {
   select: function(button, variantid, wikiid, useIndicator) {
      WorkbenchManager.addItem(variantid, wikiid, useIndicator);
      this.toggleButtonState(button, /* isOwned */ true);
   },

   deselect: function(button, variantid, wikiid, useIndicator) {
      WorkbenchManager.removeItem(variantid, wikiid, useIndicator);
      this.toggleButtonState(button, /* isOwned */ false);
   },

   toggleButtonState: function(button, isOwned) {
      var checkIcon = $$('.save-topic-check');
      var plusIcon = $$('.save-topic-plus');

      if (isOwned) {
         button.addClass('checked');
         plusIcon.addClass('hidden');
         checkIcon.removeClass('hidden');
      } else {
         button.removeClass('checked');
         checkIcon.addClass('hidden');
         plusIcon.removeClass('hidden');
      }
   },

   updateVariantDropdownState: function() {
      var button = $$('#variant-save-topic-button, #generic-save-topic-button');

      var owned = $$('.js-workbench-checkbox').some(function(checkbox) {
         return checkbox.get('checked');
      });

      TopicSelector.toggleButtonState(button, owned);
   },

   deselectVariantItems: function(wikiid) {
      $$('.js-workbench-checkbox').each(function(checkbox) {
         if (checkbox.get('checked') && checkbox.get('id') !== 'topic-generic') {
            var variantid = checkbox.get('data-topic-variantid');
            var wikiid = checkbox.get('data-wikiid');

            WorkbenchManager.removeItem(variantid, wikiid, /* useIndicator */ false);
            checkbox.set('checked', false);
         }
      });
   },
};
